import React from "react";
import Header from "../layouts/Header";
import Footer from "../layouts/Footer";
import CommissionBanner from "../bannners/commssionBanner";

function CommssionPages({ globalData }) {
  return (
    <div className="et-boc">
      <Header />
      <div id="et-main-area">
        <div id="main-content">
          <CommissionBanner sliderCommssion={globalData?.sliders?.commssion || []} />
          <Footer />
        </div>
      </div>
    </div>
  );
}

export default CommssionPages;
